/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Reference_DocsInputs */



/**
* | output |
* | --- |
* | "Reference Documents" |
*
* @param {Help_Reference_DocsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const help_reference_docs = /** @type {((inputs?: Help_Reference_DocsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Reference_DocsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Documents de référence")
	if (locale === "es") return /** @type {LocalizedString} */ ("Documentos de referencia")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Documentos de referência")
	if (locale === "it") return /** @type {LocalizedString} */ ("Documenti di riferimento")
	return /** @type {LocalizedString} */ ("Reference Documents")
});